import React from 'react';
import { Link } from 'react-router-dom';
import DrivingCarAnimation from './DrivingCarAnimation';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative bg-brand-dark text-slate-300 border-t border-slate-800">
      {/* Driving Car on the top line of Footer */}
      <DrivingCarAnimation />

      {/* Upper Footer */}
      <div className="mx-auto max-w-7xl px-6 py-16">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-4">
          {/* Company Info */}
          <div className="flex flex-col gap-6">
            <Link to="/" className="inline-block bg-white p-3 rounded-lg max-w-max">
              <img
                src="https://assets.auxodev.dk/assets/a2859b51-1b34-4d15-a97b-9fa5c0c0144f/imgi-1-logo-1_2.png"
                alt="Pabst Teknik ApS – Portservice og Sikring Logo"
                className="h-12 w-auto object-contain"
              />
            </Link>
            <p className="text-sm text-slate-400 leading-relaxed">
              Din lokale port- og sikringspartner i Vejen. Vi leverer, monterer og servicerer alle typer porte samt intelligente Ajax sikringssystemer i hele Sydøstjylland.
            </p>
            <div className="flex items-center gap-3">
              <a
                href="https://www.facebook.com/Pabstteknik/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex h-10 w-10 items-center justify-center rounded-full bg-slate-800 text-white transition-colors hover:bg-brand-accent hover:text-white"
                aria-label="Følg os på Facebook"
              >
                <i className="fa-brands fa-facebook-f" />
              </a>
              <a
                href="https://www.linkedin.com/in/dansk-portservice-v-pabstteknik-36083722b"
                target="_blank"
                rel="noopener noreferrer"
                className="flex h-10 w-10 items-center justify-center rounded-full bg-slate-800 text-white transition-colors hover:bg-brand-accent hover:text-white"
                aria-label="Følg os på LinkedIn"
              >
                <i className="fa-brands fa-linkedin-in" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-display text-base font-bold text-white uppercase tracking-wider mb-6">Navigation</h3>
            <ul className="flex flex-col gap-3.5 text-sm">
              <li>
                <Link to="/" className="hover:text-white transition-colors">Forside</Link>
              </li>
              <li>
                <Link to="/om-os" className="hover:text-white transition-colors">Om Pabst Teknik ApS</Link>
              </li>
              <li>
                <Link to="/ydelser" className="hover:text-white transition-colors">Vi tilbyder</Link>
              </li>
              <li>
                <Link to="/galleri" className="hover:text-white transition-colors">Billedgalleri</Link>
              </li>
              <li>
                <Link to="/kontakt" className="hover:text-white transition-colors">Kontakt os</Link>
              </li>
            </ul>
          </div>

          {/* Services Links */}
          <div>
            <h3 className="font-display text-base font-bold text-white uppercase tracking-wider mb-6">Vi tilbyder</h3>
            <ul className="flex flex-col gap-3.5 text-sm">
              <li>
                <Link to="/ydelser/portservice-og-lovpligtigt-eftersyn" className="hover:text-white transition-colors font-medium text-brand-accent-light">Portservice & Eftersyn</Link>
              </li>
              <li>
                <Link to="/ydelser/garageporte" className="hover:text-white transition-colors">Garageporte</Link>
              </li>
              <li>
                <Link to="/ydelser/friporte" className="hover:text-white transition-colors">Friporte & Skydeporte</Link>
              </li>
              <li>
                <Link to="/ydelser/industriporte" className="hover:text-white transition-colors">Industriporte</Link>
              </li>
              <li>
                <Link to="/ydelser/hurtigporte" className="hover:text-white transition-colors">Hurtigporte</Link>
              </li>
              <li>
                <Link to="/ydelser/alarmsystem" className="hover:text-white transition-colors">Ajax Alarmsystemer</Link>
              </li>
              <li>
                <Link to="/ydelser/alarmsystem-video-overvaagning" className="hover:text-white transition-colors">Videoovervågning</Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-display text-base font-bold text-white uppercase tracking-wider mb-6">Kontakt Info</h3>
            <ul className="flex flex-col gap-4 text-sm">
              <li className="flex items-start gap-3">
                <i className="fa-regular fa-map-pin text-brand-accent mt-1" />
                <span className="leading-relaxed">
                  Pabst Teknik ApS<br />
                  Gestenvej 29<br />
                  6600 Vejen
                </span>
              </li>
              <li className="flex items-center gap-3">
                <i className="fa-regular fa-phone text-brand-accent" />
                <a href="tel:+4521684422" className="hover:text-white transition-colors">21 68 44 22</a>
              </li>
              <li className="flex items-center gap-3">
                <i className="fa-regular fa-envelope text-brand-accent" />
                <a href="mailto:kontakt@pabstteknik.dk" className="hover:text-white transition-colors">kontakt@pabstteknik.dk</a>
              </li>
              <li className="flex items-center gap-3">
                <i className="fa-regular fa-id-card text-brand-accent" />
                <span>CVR: 42228842</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Lower Footer */}
      <div className="border-t border-slate-800 bg-slate-950/50 py-8">
        <div className="mx-auto max-w-7xl px-6 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-slate-500">
          <p>© {currentYear} Pabst Teknik ApS. Alle rettigheder forbeholdes.</p>
          <div className="flex flex-wrap items-center justify-center md:justify-end gap-4 sm:gap-6">
            <a
              href="https://0298fb46-c259-4129-b655-7c68adb8d499.sites.auxodev.dk/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1.5 text-xs text-slate-400 hover:text-white bg-slate-900/90 hover:bg-slate-800 border border-slate-800 hover:border-slate-700 px-3 py-1.5 rounded-lg transition-all"
            >
              <i className="fa-solid fa-handshake text-brand-accent" />
              <span>Samarbejdspartner: Dansk Portservice Claus Hygum ApS</span>
              <i className="fa-solid fa-arrow-up-right-from-square text-[10px] text-slate-500" />
            </a>
            <span>Udviklet med fokus på sikkerhed og kvalitet</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
